import axios from "axios";
import { useEffect, useState } from "react";
import { getLocalTime } from "../../utils/dateTimeByTZ";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import FolderIcon from "@mui/icons-material/Folder";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { BrowserRouter as Router, Route, Routes, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from '@mui/icons-material/Edit';
import { useSearchParams } from 'react-router-dom';

type Props = {};
interface FileItem {
    id: string;
    fileName: string;
    type: string;
    url?: string;
    date: Date;
}


const FolderView = (props: Props) => {
    const BASE_URL = process.env.REACT_APP_API_KEY;
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [disable, setDisable] = useState(false);
    const [openDialogId, setOpenDialogId] = useState<null | string>(null);
    const [loading, setLoading] = useState(false);
    const [openFolderDialog, setOpenFolderDialog] = useState(false);
    const [folderName, setFolderName] = useState("");
    const [openAddDocDialog, setOpenAddDocDialog] = useState(false); // State for the Add Document dialog
    const [currentFolderId, setCurrentFolderId] = useState(" ");
    const [selectedFolder, setselectedFolder] = useState(" ")
    const [folderList, setFolderList] = useState([])
    const [checkForFolderName, setcheckForFolderName] = useState(false)
    const [editFolderID, setEditFolderID] = useState(null)
    const [openFolderEditDialog, setOpenEditFolderDialog] = useState(false);
    const [editFileType, setEditFileType] = useState("");
    const [searchParams] = useSearchParams();
    const createdBy = searchParams.get('createdBy');
    const navigate = useNavigate();
    const id = useParams();
    const [sysNumber, setsysNumber] = useState(localStorage.getItem("systemNumber"));

    const showToast = (message: string, type: "success" | "error") => {
        toast[type](message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
        });
    };

    const handleFolderClick = (folderId: any) => {
        // Navigate to the folder's page
        navigate(`/folder/${folderId}`);
    };

    const handleEditDialog = (folder: any) => {
        if (folder.folderId) {
            setEditFolderID(folder.folderId);
            setEditFileType("Folder");
            setFolderName(folder.fileName);
        } else {
            setEditFolderID(folder.id);
            setEditFileType("File");
            setFolderName(folder.fileName.split('.')[0]);
        }

        setOpenEditFolderDialog(true);
        setcheckForFolderName(false);

        // navigate(`/folder/${folderId}`);
    };

    const handleOpenAddDocDialog = (folderId: any) => {
        setCurrentFolderId(folderId);
        setOpenAddDocDialog(true);
    };

    const handleInputChange = (event: any) => {
        if (!editFolderID) {
            let checkDocName = folderList.some((folder: any) => folder.foldername === event.target.value)
            setcheckForFolderName(checkDocName)
            setFolderName(event.target.value);
        } else {
            let checkDocName = folderList.some((folder: any) => folder.folderId !== editFolderID && folder.foldername === event.target.value);
            setcheckForFolderName(checkDocName)
            setFolderName(event.target.value);
        }

    };

    const handleChangeFolderName = async (event: React.ChangeEvent<HTMLSelectElement>, item: any) => {
        const token = localStorage.getItem("authtoken") || "";

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = await axios.post(
                `${BASE_URL}/document/updateFolderId`,
                { id: item.id, folderId: event.target.value },
                config
            );
            if (response.data.success) {
                fetchDocuments();
                fetchFolderNames();
            }

        } catch (error) {
            console.error("Error fetching documents:", error);
        } finally {
            setLoading(false);
        }
    }

    const handleCloseFolderDialog = () => {
        setOpenFolderDialog(false);
        setFolderName(""); // Reset the folder name
    };

    const handleCloseEditFolderDialog = () => {
        setOpenEditFolderDialog(false);
        setFolderName(""); // Reset the folder name
    };

    const [files, setFiles] = useState<{ id: string; fileName: string; type: string; date: Date }[]>([]);
    // const [folders, setFolders] = useState<{ folderid: string; fileName: string; type: string; date: Date }[]>([]);

    const handleCreateFolder = async () => {
        if (!folderName.trim()) return;
        const SystemNumber = localStorage.getItem("systemNumber");
        const token = localStorage.getItem("authtoken") || "";

        const newFolder = {
            foldername: folderName,
            date: new Date(),
            systemNumber: SystemNumber,
            folderId: Math.random().toString(36).substr(2, 9)
        };

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.post(
            `${BASE_URL}/document/insertDocumentFolder`,
            newFolder,
            config,
        );
        setEditFolderID(null)
        setEditFileType(" ")

        // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
        // existingFolders.unshift(newFolder);
        // localStorage.setItem("folders", JSON.stringify(existingFolders));

        fetchDocuments();
        fetchFolderNames();
        showToast("Folder created successfully", "success");
        setOpenFolderDialog(false);
        setFolderName(""); // Clear folder name after success
    };

    const handleEditFolder = async () => {
        if (!folderName.trim()) return;
        const SystemNumber = localStorage.getItem("systemNumber");
        const token = localStorage.getItem("authtoken") || "";
        if (editFileType === "Folder") {
            const editFolder = {
                foldername: folderName,
                date: new Date(),
                systemNumber: SystemNumber,
                folderId: editFolderID
            };

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await axios.post(
                `${BASE_URL}/document/editDocumentFolder`,
                editFolder,
                config,
            );
            setEditFolderID(null)
            setEditFileType(" ")

            // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
            // existingFolders.unshift(newFolder);
            // localStorage.setItem("folders", JSON.stringify(existingFolders));

            fetchDocuments();
            fetchFolderNames();
            showToast("Folder Renamed successfully", "success");
            setOpenEditFolderDialog(false);
            setFolderName(""); // Clear folder name after success
        } else {
            const editFile = {
                filename: folderName,
                id: editFolderID
            };

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const response = await axios.post(
                `${BASE_URL}/document/editDocumentFile`,
                editFile,
                config,
            );
            setEditFolderID(null)
            setEditFileType(" ")

            // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
            // existingFolders.unshift(newFolder);
            // localStorage.setItem("folders", JSON.stringify(existingFolders));

            fetchDocuments();
            fetchFolderNames();
            showToast("File Renamed successfully", "success");
            setOpenEditFolderDialog(false);
            setFolderName(""); // Clear folder name after success
        }
    };

    const fetchDocuments = async () => {
        setLoading(true);
        setFiles([]);
        const SystemNumber = localStorage.getItem("systemNumber");
        const token = localStorage.getItem("authtoken") || "";

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = await axios.get(
                `${BASE_URL}/document/getDocumentsByFolder/${SystemNumber}?page=${page}&folderId=${id.folderId}`,
                config
            );
            const backendFiles = response.data.allDocuments;
            setTotalPages(response.data.totalPages);

            // const localFolders = JSON.parse(localStorage.getItem("folders") || "[]");
            const allFiles = [...backendFiles];
            setFiles(allFiles);
        } catch (error) {
            console.error("Error fetching documents:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchFolderNames = async () => {
        setLoading(true);
        const token = localStorage.getItem("authtoken") || "";
        const sytemNumber = localStorage.getItem("systemNumber") || "";

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const response = await axios.get(
                `${BASE_URL}/document/getFolderNames/${sytemNumber}`,
                config
            );
            let backendFiles = response.data.folderName;
            backendFiles = backendFiles.filter((fol: any) => {
                return fol.folderId !== id.folderId
            })
            // setTotalPages(response.data.totalPages);

            // const localFolders = JSON.parse(localStorage.getItem("folders") || "[]");
            // const allFiles = [...localFolders, ...backendFiles];
            setFolderList(backendFiles);
        } catch (error) {
            console.error("Error fetching documents:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocuments();
        fetchFolderNames();
    }, [page]);

    const handleNext = () => {
        setPage((prevPage) => prevPage + 1);
    };

    const handlePrevious = () => {
        setPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const handleOpenDialog = (id: string) => {
        setOpenDialogId(id);
    };

    const handleCloseDialog = () => {
        setOpenDialogId(null);
        setEditFolderID(null)
        setEditFileType(" ")
    };

    const handleDeleteDoc = async (item: any) => {
        const token = localStorage.getItem("authtoken") || "";
        setOpenDialogId(null);
        try {
            // if (item.type === "folder") {
            //   const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
            //   const updatedFolders = existingFolders.filter((folder: { id: any; }) => folder.id !== item.id);
            //   localStorage.setItem("folders", JSON.stringify(updatedFolders));
            //   showToast("Folder deleted successfully", "success");
            //   fetchDocuments();
            // } else {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const deleteResponse = await axios.delete(
                `${BASE_URL}/document/delete/${item.id}?type=${item.type}`,
                config
            );

            if (deleteResponse.data.success) {
                showToast(deleteResponse.data.message, "success");
                fetchDocuments();
                fetchFolderNames();
            } else {
                showToast("Failed to delete document", "error");
            }
        }
        catch (error) {
            showToast("Error deleting item", "error");
        }
    };

    const documents = files.map((file: any) => ({
        id: file._id || file.id,
        fileName: file.originalFileName || file.fileName,
        type: file.mimetype || "folder",
        url: file.url,
        date: file.date,
        folderId: file.folderId,
    }));

    const handleDownload = (url: string, fileName: string) => {
        setDisable(true);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        setDisable(false);
    };

    const handleBack = () => {
        navigate(`/documents`)
    };

    return (
        <div>
            <ToastContainer />
            <div className="card-list">
                <Button
                    onClick={() => {
                        handleBack();
                    }}
                    style={{
                        float: "right",
                        cursor: disable ? "not-allowed" : "pointer",
                    }}
                    sx={{ color: "#134fcf !important" }}
                    startIcon={<ArrowBackIcon />}
                >
                    Back
                </Button>
            </div>


            <hr />

            {loading ? (
                <div style={{ textAlign: "center" }}>
                    <CircularProgress sx={{ color: "#134fcf !important" }} />
                </div>
            ) : (
                <div>
                    {documents.length === 0 ? (
                        <div style={{ textAlign: "center" }}>
                            <b>No Documents Uploaded</b>
                        </div>
                    ) : (
                        <div className="list-container">
                            {documents.map((item) => (
                                <div className="card" key={item?.id} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", cursor: "pointer" }}>
                                    <div>
                                        {item.type === "folder" ? (
                                            <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} >
                                                <FolderIcon style={{ marginRight: "10px" }} />
                                                <h4 style={{ fontWeight: "bold" }}>{item.fileName}</h4>
                                            </div>
                                        ) : (
                                            <h4 style={{ fontWeight: "bold" }}>{item.fileName}</h4>
                                        )}
                                        <p>{getLocalTime(item.date)}</p>
                                        {item.type !== "folder" && sysNumber === "15063" || sysNumber === createdBy ? (
                                            <select
                                                id="dropdown"
                                                value={selectedFolder}
                                                onChange={(event) => handleChangeFolderName(event, item)} // Pass event and item as arguments
                                            >
                                                <option value="">Select a Folder</option>
                                                <option value="Unlink File">Unlink File</option>
                                                {folderList.map((item: any) => (
                                                    ((item.systemNumber.includes(sysNumber) && sysNumber !== '15063') || sysNumber == '15063') && (
                                                        <option key={item.folderId} value={item.folderId}>
                                                            {item.foldername}
                                                        </option>
                                                    )
                                                ))}
                                            </select>
                                        ) : null}
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        {item.type !== "folder" && (
                                            <>

                                                <button className="blue" style={{ alignSelf: "center" }} onClick={() => handleDownload(item.url, item.fileName)} disabled={disable}>
                                                    Download
                                                </button>
                                                <br />
                                            </>
                                        )}
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            {item.type === "folder" && (
                                                <button className="blue" onClick={() => handleOpenAddDocDialog(item.folderId)} style={{ marginLeft: "10px" }}>
                                                    Add Document
                                                </button>
                                            )}
                                            {item.type === "folder" && (
                                                <button className="blue" onClick={() => handleFolderClick(item.folderId)} style={{ marginLeft: "10px" }}>
                                                    Open Folder
                                                </button>
                                            )}
                                            {(sysNumber === "15063" || sysNumber === createdBy) && (
                                                <>
                                                    <Button
                                                        variant="contained"
                                                        className="muiButton blue"
                                                        onClick={() => handleEditDialog(item)}
                                                        style={{ marginLeft: "10px" }}
                                                    >
                                                        <EditIcon />
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        className="muiButton"
                                                        onClick={() => handleOpenDialog(item.id)}
                                                        style={{
                                                            backgroundColor: "red",
                                                            color: "white",
                                                            marginLeft: "10px",
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </Button>
                                                    <Dialog open={openDialogId === item.id} onClose={handleCloseDialog}>
                                                        <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description">
                                                                Are you sure you want to delete {item.fileName}?
                                                            </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button onClick={handleCloseDialog} sx={{ color: "#134fcf" }}>
                                                                Cancel
                                                            </Button>
                                                            <Button onClick={() => handleDeleteDoc(item)} sx={{ color: "#134fcf" }}>
                                                                Yes
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {totalPages > 1 ? (
                <div className="pagination">
                    <Button onClick={handlePrevious} disabled={page === 1} sx={{ color: "#134fcf" }}>Prev</Button>
                    <Button onClick={handleNext} disabled={page === totalPages} sx={{ color: "#134fcf" }}>Next</Button>
                </div>
            ) : null}


            <Dialog open={openFolderDialog} onClose={handleCloseFolderDialog}>
                <DialogTitle>Create Folder</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Folder Name"
                        fullWidth
                        value={folderName}
                        onChange={handleInputChange}
                        autoFocus
                    />
                    {checkForFolderName ? (
                        <p style={{ color: 'red' }}>Folder Name Already Exists</p>
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseFolderDialog} sx={{ color: "#134fcf" }}>Cancel</Button>
                    <Button onClick={handleCreateFolder} sx={{ color: "#134fcf" }} disabled={!folderName.trim() || checkForFolderName}>Create Folder</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openFolderEditDialog} onClose={handleCloseEditFolderDialog}>
                <DialogTitle>{editFileType === "Folder" ? (
                    <span>Edit Folder Name</span>
                ) : <span>Edit File Name</span>
                }</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Folder Name"
                        fullWidth
                        value={folderName}
                        onChange={handleInputChange}
                        autoFocus
                    />
                    {checkForFolderName ? (
                        <p style={{ color: 'red' }}>Folder Name Already Exists</p>
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEditFolderDialog} sx={{ color: "#134fcf" }}>Cancel</Button>
                    <Button onClick={handleEditFolder} sx={{ color: "#134fcf" }} disabled={!folderName.trim() || checkForFolderName}>{editFileType === "Folder" ? (
                        <span>Edit Folder</span>
                    ) : <span>Edit File</span>
                    }</Button>
                </DialogActions>
            </Dialog>

        </div >
    );
};

export default FolderView;


